// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// SHARED COMPONENTS
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// PAGE COMPONENTS
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ScrollToTop from './components/ScrollToTop';
import ContactPage from './pages/ContactPage';
import ProductPage from './pages/ProductPage';
import ProjectPage from './pages/ProjectPage';
import WhatsAppButton from './components/WhatsAppButton';
import NotFoundPage from './pages/NotFoundPage';
import DownloadCataloguesPage from "./pages/DownloadCataloguesPage";

function App() {
  const handleContextMenu = (e) => { e.preventDefault(); };
  const handleKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && ['c', 'v', 's', 'p', 'u', 'a'].includes(e.key.toLowerCase())) {
      e.preventDefault();
    }
    if (e.key === 'F12') { e.preventDefault(); }
  };

  return (
    // We wrap the components in a React Fragment <>...</> so we can have multiple top-level elements
    <>
      <div
        className="app-container"
        onContextMenu={handleContextMenu}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        <Router>
          <ScrollToTop />
          <Navbar />  

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contactus" element={<ContactPage />} />
            <Route path="/products" element={<ProductPage />} />
            <Route path="/projects" element={<ProjectPage />} />
            <Route path="/projects/:projectId?" element={<ProjectPage />} />
            <Route path="/download-catalogues" element={<DownloadCataloguesPage />} />


            <Route path="*" element={<NotFoundPage />} />
          </Routes>

          <Footer />
        </Router>
      </div>

      {/* --- THE FIX IS HERE --- */}
      {/* The WhatsAppButton is now OUTSIDE of the .app-container div. */}
      {/* This ensures its position is fixed relative to the browser window. */}
      <WhatsAppButton />
    </>
  );
}

export default App;